import { useContext } from 'react'
import EnvConfigContext from './EnvConfigContext'
import type { EnvConfig } from './envConfig'

export const useConfig = (): EnvConfig => {
  const { envConfig } = useContext(EnvConfigContext)
  return envConfig
}
